/* ============
 * All License Types
 * ============
 *
 * All license types.
 */

import Vue from 'vue';
import store from '../../store';
import licenseTransformer from '../../transformers/license';

const success = ({ data }, resolve) => {
  if (data.data.length) {
    const licenses = licenseTransformer.fetchCollection(data.data);
    store.dispatch('fetchAllLicenses', licenses);
  }
  resolve();
};

const failed = (error, reject) => reject(error);

// Display license types.
export default clientId => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`license?client_id=${clientId}`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/license/all.js